export {
  ProductKey,
  type ProductLicense,
  type ApplicationLicense,
} from '@bbk/admin-runtime/session';

import { type ProductLicense } from '@bbk/admin-runtime/session';
import { bbkApiSlice } from '@bbkAdminRedux/rtkq/bbkApi.slice';

export const productSlice = bbkApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProductLicenses: builder.query<ProductLicense[], void>({
      query: () => `/dev/productLicenses`,
      providesTags: ['Products'],
    }),
  }),
});
